import { ObsoleteBinary, Request } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { CommonApiUri } from './uri';

export class CommonApi {
  public static async deleteObsoleteBinaries() {
    const response = await Http.delete<Request>(
      CommonApiUri.OBSOLETE_BINARIES_URL
    );
    return response.data;
  }

  public static async getObsoleteBinaries() {
    const response = await Http.get<ObsoleteBinary[]>(
      CommonApiUri.OBSOLETE_BINARIES_URL
    );
    return response.data;
  }
}
